module.exports = __webpack_public_path__ + "static/media/banner5.1bbefef6.png";